var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconFreeDoc = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4cbac0",
  d: "M12.3 4.4h-10C1.4 4.4.7 5.1.7 6v11.7h1.7V6h10l-.1-1.6zm-.8 3.3l5 5V21c0 .9-.7 1.7-1.7 1.7H5.7c-1 0-1.7-.8-1.7-1.7V9.4c0-.9.7-1.7 1.7-1.7h5.8zm-.8 5.8h4.6L10.7 9v4.5zm7.9-12.2c-2.3 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3c2.3 0 4.3-1.9 4.3-4.3S21 1.3 18.6 1.3zm1.6 6.5l-1.6-1-1.6 1 .5-1.9L16 4.7l1.9-.1.7-1.8.7 1.8 1.9.1-1.5 1.2.5 1.9z"
})));
export default SvgIconFreeDoc;